module.exports = __webpack_public_path__ + "media/images/championship__iconWrong-123205e36a9f8211b7c59fe12423d89c.png";